import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import ReturnAddressForm from '@/components/settings/ReturnAddressForm';

/**
 * Add a return address without leaving the Mail page.
 *
 * Wraps the same form Settings uses rather than a second copy — a divergence
 * between the two would mean an address added here validates differently from
 * one added there.
 */
export default function ReturnAddressDialog({ open, onClose, onSaved }) {
  return (
    <Dialog open={open} onOpenChange={(next) => !next && onClose()}>
      <DialogContent className="sm:max-w-lg max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Add return address</DialogTitle>
        </DialogHeader>

        <ReturnAddressForm
          onClose={() => {
            onSaved?.();
            onClose();
          }}
        />
      </DialogContent>
    </Dialog>
  );
}
